import React from 'react'
import SarasAllRowSelector from "../../../../library/hooks/selector/SarasAllRowSelector";
import Icon from '../../../../library/decor/SarasIcons';
import SarasTooltip from '../../../../library/notifications/SarasTooltip';

const DocTableHeaderColumn = ({col, index, viewMap, onClick})=>{
    const colRef = React.useRef(null);

    // console.log("header column ", col);

    const onColClicked = (e) => {
        if(onClick) onClick(colRef, col.dataList.searchKey);
    }

    const renderHeaderColumn = () => {
        // console.log("table view", col.viewKey);
        let DynamicComponent = viewMap[col.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = viewMap["vCMNGridHeaderLabel"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return <DynamicComponent col={col} />
        }
    }

    //render with click to trigger search filter
    if(col.dataList.searchKey && col.dataList.searchKey.length > 0)
    {
        let BtnFilterIcon = Icon["filter"];

        return (
            <td ref={colRef} className={col.dataList.colCssClass} onClick={onColClicked}
            searchkey={col.dataList.searchKey} key={index}>
                <SarasTooltip title="Click to filter" >
                    <div className="uiLabelWithAction">
                        <span className="uiLWALabel" >
                            {renderHeaderColumn()}
                        </span>
                        <span className="uiLWAAction">
                            <BtnFilterIcon className="uiSearchHeaderFilter" />
                        </span>
                    </div>
                </SarasTooltip>
            </td>
        );
    }
    else
    {
        //no header click enabled
        return (
            <td className={col.dataList.colCssClass} key={index}>
                {renderHeaderColumn()}
            </td>
        );
    }
}

const DocTableHeader = (props)=>{
    const {viewData, onSearchRequest, rowSelector, viewMap} = props;

    // console.log("render table header", viewData);

    //this will be active only if the parent container passes the onSearchRequest callback
    const onHeaderColumnClicked = (anchorRef, fieldKey) => {
        // console.log("header clicked", anchorRef, fieldKey);
        if(onSearchRequest) onSearchRequest(anchorRef, fieldKey);
    }

    return(
        <tr style={{position:'relative'}} className={viewData.dataList.cssClass}>
            <SarasAllRowSelector rowSelector={rowSelector} customWrapper="td" wrapperStyle={{width:'80px'}} className="uiRowAllSelector" wrapperClass="uiCheckRowSelector"/>
            {
                Object.values(viewData.rowValues).sort((a, b) => a.sortKey - b.sortKey).map((col,index)=>(
                    <DocTableHeaderColumn viewMap={viewMap} col={col} index={index} key={index} onClick={onHeaderColumnClicked}/>
                ))
            }
        </tr>
    )
}

export default DocTableHeader